import axois from '../utils/axiosExport'

// 提交资金变动申请（充值 - 提现） 
export function submitFundChange(data?: any) {
  return axois.request({
    url: `/admin/recharge`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 分页查询资金变动记录 
export function getFundChangeList(data?: any) {
  return axois.request({
    url: `/admin/recharge/page`,
    method: "POST", 
    data: {
      ...data,
    },
  });
}